const styles = (theme) => ({
  deviceSelectWrapper: {
    width: '50%',
  },
})

export default styles
